import { createAction, createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';
import { type SagaConfig } from '@sagas/request/types';

import { type MarketplacesState } from './types';

export const initialState: MarketplacesState = {
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
  model: [],
};

export const marketplacesRequest = createAction<{ sagaConfig?: SagaConfig }>(
  'marketplaces/request'
);

const marketplaces = createSlice({
  name: 'marketplaces',
  initialState,
  reducers: {
    reset: () => initialState,
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
  },
  extraReducers: builder => {
    builder.addCase(marketplacesRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    });
  },
});

export const {
  reset: marketplacesReset,
  success: marketplacesSuccess,
  failure: marketplacesFailure,
} = marketplaces.actions;

export default marketplaces.reducer;
